import { render, staticRenderFns } from "./Pdf.vue?vue&type=template&id=5fd1a60d&"
import script from "./Pdf.vue?vue&type=script&lang=ts&"
export * from "./Pdf.vue?vue&type=script&lang=ts&"
import style0 from "./Pdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports